import React from 'react'

import { getPrice } from "../../utils";
import { Token } from "../../types";
import { tokensToBuy } from "../../config";

import {
    TokenContainer,
    StyledLockOpenIcon,
    TokenTitle,
    TokenPrice,
    TokenDescription,
    TokenDiscount,
    StyledLocalOfferOutlinedIcon,
    InfoLink
} from "./Tokens.styles";
import {
    PopupContainer,
    PopupTitleContainer,
    PopupTitle,
    StyledCrossButtonDark,
    Description,
} from "../../common.styles";

interface TokensProps {
    onCloseButtonClick: () => void,
    onTokenClick: (token: Token) => void,
    country: string,
    infoLink: string
}

const Tokens = ({ onCloseButtonClick, onTokenClick, country, infoLink }: TokensProps) => {
    const onInfoLinkClick = () => {
        // @ts-ignore
        window.Cordova ? cordova.InAppBrowser.open(
                infoLink,
                '_system',
                'location=yes'
            )
            : window.open(
                infoLink,
                '_blank',
                'location=yes'
            )
    }

    return (
        <PopupContainer>
            <PopupTitleContainer>
                <PopupTitle>Buy tokens</PopupTitle>
                <StyledCrossButtonDark className="no-fastclick" onClick={onCloseButtonClick}/>
            </PopupTitleContainer>
            <Description>
                You’ll need to buy some tokens to view resumés. It costs 1 token to unlock a resumé, after which you can view it unlimited times.
            </Description>
            <div>
                {tokensToBuy.map((token) => {
                    const {id, count, price, discount} = token;

                    return (
                        <TokenContainer key={id} onClick={() => onTokenClick(token)}>
                            <StyledLockOpenIcon />
                            <div>
                                <TokenTitle>Unlock {count} {count <= 1 ? 'Resumé' : 'Resumés'}</TokenTitle>
                                <TokenDescription>
                                    <TokenPrice>{getPrice({price, discount, countryCode: country})}</TokenPrice>
                                    {discount ? (
                                        <TokenDiscount>
                                            <StyledLocalOfferOutlinedIcon />
                                            <span>Save {discount}%</span>
                                        </TokenDiscount>
                                    ) : null}
                                </TokenDescription>
                            </div>
                        </TokenContainer>
                    )
                })}
            </div>
            <InfoLink
                href="#"
                className="no-fastclick"
                onClick={onInfoLinkClick}
            >
                More information about Tokens
            </InfoLink>
        </PopupContainer>
    );
}

export default Tokens;
